'use strict';
'use client';
import { j as a } from "../../external/react/jsx-runtime.js";
import t from "../../external/classnames/index.js";
import { useTheme as C } from "../Provider/index.js";
import T from "../Loading/index.js";
import { faArrowRightLong as $ } from "../../external/@fortawesome/pro-regular-svg-icons/index.js";
import { FontAwesomeIcon as L } from "../../external/@fortawesome/react-fontawesome/index.es.js";
const I = ({
  as: h,
  variant: d = "primary",
  className: u,
  children: c,
  text: m,
  onClick: p,
  size: o = "regular",
  isLoading: g = !1,
  stretch: x = !1,
  icon: y = $,
  ...f
}) => {
  const w = h || "button", { isMosh: r, isMoshy: n } = C(), v = {
    primary: t(
      "disabled:bg-grey-100 border-transparent disabled:text-grey-400 text-white",
      {
        "bg-purple-dark hover:bg-btn-primary-secondary-hover": n,
        "bg-orange hover:bg-orange-dark": r
      }
    ),
    secondary: t(
      "disabled:border-grey-300 disabled:text-grey-300 disabled:bg-transparent bg-transparent",
      {
        "border-green-dark text-green-dark hover:bg-green-dark hover:text-white": r,
        "border-purple-dark text-purple-dark hover:bg-btn-primary-secondary-hover hover:text-white": n
      }
    ),
    secondaryLight: t(
      "disabled:border-grey-300 bg-transparent disabled:text-grey-300 disabled:bg-transparent border-white text-white",
      {
        "hover:bg-green-faint-dark": r,
        "hover:bg-purple-light": n
      }
    ),
    tertiary: t(
      "border-transparent disabled:bg-transparent disabled:text-grey-300 bg-transparent",
      {
        "bg-none text-green-dark hover:bg-green-light": r,
        "bg-none text-purple-dark hover:bg-btn-tertiary-hover": n
      }
    ),
    tertiaryLight: t(
      "disabled:bg-transparent disabled:text-grey-300 bg-transparent border-transparent text-white",
      {
        "hover:bg-green-faint-dark": r,
        "hover:bg-purple-light": n
      }
    ),
    ghost: t(
      "bg-transparent disabled:bg-transparent disabled:text-grey-400 border-none !p-0 flex flex-row justify-center gap-2 !rounded-none",
      {
        "hover:text-green-faint-dark text-green-dark": r,
        "hover:hover:text-purple text-purple-dark": n
      }
    )
  }, k = (s) => {
    const b = s.currentTarget, e = document.createElement("span"), l = b.getBoundingClientRect(), i = Math.max(l.width, l.height), j = s.clientX - l.left - i / 2, N = s.clientY - l.top - i / 2;
    e.className = t(
      "absolute opacity-50 rounded-full pointer-events-none bg-white"
    ), e.style.width = `${i}px`, e.style.height = `${i}px`, e.style.left = `${j}px`, e.style.top = `${N}px`, e.style.transform = "scale(0)", e.style.transition = "transform 400ms, opacity 400ms", b.appendChild(e), setTimeout(() => {
      e.style.transform = "scale(2)", e.style.opacity = "0";
    }, 0), setTimeout(() => {
      e.remove();
    }, 400), p && p(s);
  };
  return /* @__PURE__ */ a.jsxs(
    w,
    {
      ...f,
      "data-button-variant": d,
      className: t(
        "font-demi rounded-lg border shadow-none cursor-pointer relative inline-block text-center whitespace-nowrap overflow-hidden transition-all duration-200 ease-in-out disabled:cursor-auto w-full",
        o === "small" ? "text-sm leading-[14px] px-3 py-2" : null,
        o === "regular" ? "text-base leading-4 px-6 py-4" : null,
        v[d],
        x ? "md:max-w-[398px] md:w-full" : "md:w-auto",
        u
      ),
      onClick: k,
      children: [
        /* @__PURE__ */ a.jsxs(
          "span",
          {
            className: t("flex items-center justify-center", {
              invisible: g
            }),
            children: [
              m,
              c
            ]
          }
        ),
        g ? /* @__PURE__ */ a.jsx("span", { className: "absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ a.jsx(
          T,
          {
            inline: !0,
            size: t(
              o === "small" ? "h-4 w-4" : null,
              o === "regular" ? "h-6 w-6" : null
            )
          }
        ) }) : null,
        d === "ghost" ? /* @__PURE__ */ a.jsx(L, { icon: y }) : null
      ]
    }
  );
};
export {
  I as default
};
